import React, { useEffect } from "react";
import "./Learn_Something_New.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import { useDispatch, useSelector } from "react-redux";
import { AllLearnVideos } from "../../../features/admin/common/Slice";

const Learn_Something_New = () => {
  const dispatch = useDispatch();
  const learn_video = useSelector((state) => state.common.all_learn_video);

  useEffect(() => {
    dispatch(AllLearnVideos());
  }, [dispatch]);

  // Extract YouTube Video ID
  const getYoutubeId = (url) => {
    if (!url) return "";

    if (url.includes("shorts")) {
      return url.split("shorts/")[1];
    }

    if (url.includes("watch?v=")) {
      return url.split("watch?v=")[1];
    }

    if (url.includes("youtu.be/")) {
      return url.split("youtu.be/")[1];
    }

    return "";
  };

  // Get thumbnail URL
  const getThumbnail = (url) => {
    const id = getYoutubeId(url);
    return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
  };




  const getEmbedUrl = (url) => {
    if (!url) return "";

    // YouTube
    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      const videoId = url.split("v=")[1]?.split("&")[0] || url.split("/").pop();
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Vimeo
    if (url.includes("vimeo.com")) {
      const videoId = url.split("/").pop();
      return `https://player.vimeo.com/video/${videoId}`;
    }

    return url;
  };

  return (
    <section className="Learn_Something_New">
      <div className="container">
        <div className="Learn_Something_New_header">
          <h5 className="learn_title">
            Learn Something New In <span>60 Seconds </span>
          </h5>
        </div>

        <div className="learn_new_swiper_holder">
          <Swiper
            modules={[Pagination, Autoplay]}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            spaceBetween={20}
            slidesPerView={1}
            loop
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1 },
              320: { slidesPerView: 2 },
              575: { slidesPerView: 3 },
              768: { slidesPerView: 3.5 },
              992: { slidesPerView: 4 },
              1200: { slidesPerView: 4 },
            }}
            className="mySwiper"
          >
            {learn_video.map((item) => (
              <SwiperSlide key={item.id}>
                <div
                  className="card_wrapper"
                  style={{ cursor: "pointer" }}
                  onClick={() => window.open(item.url, "_blank")}
                >
                  {/* <img
                    src={getThumbnail(item.url)}
                    alt={`video-${item.id}`}
                    width="100%"
                    height="100%"
                    style={{ objectFit: "cover" }}
                  /> */}
                

                  <iframe
                    width="100%"
                    height="300"
                    src={getEmbedUrl(item.url)} // IMPORTANT: must return embed URL
                    title={`video-${item.id}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>

                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Learn_Something_New;